export const linkTypes = {
	actionLink: 1,
	publicPortalLink: 2,
	preferencePageLink: 3
}
